@if (!hasOpenId) {
  <div class="reauth-container">
    <button type="button" (click)="onReauthStart()" class="btn btn-primary" [disabled]="busy">
      {{'Click to start OpenID auth' | translate}}
    </button>
  </div>
}
@if (hasOpenId) {
  <div class="reauth-container">
    <p>{{'User ID:' | translate}} {{userId}}</p>
  </div>
}
<div class="reauth-container">
  <p>{{stateMessage}}</p>
  @if (blocked) {
    <p>{{'You have blocked this widget from receiving credentials.' | translate}}</p>
  }
  @if (error) {
    <p>{{'An error has occurred - see logs for details' | translate}}</p>
  }
  <small>Widget ID: {{widgetId}}</small>
</div>
